import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";

var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import { above } from './above';
export var mapTheme = function mapTheme(fn) {
  return function (props) {
    var breakpoints = props.theme.griding.breakpoints;
    return Object.keys(breakpoints).map(function (label) {
      return above(label)(_templateObject, fn(breakpoints[label], props));
    });
  };
};
export var mapBreakpoints = function mapBreakpoints(fn) {
  return function (props) {
    var breakpoints = props.theme.griding.breakpoints;
    return Object.keys(props).filter(function (prop) {
      return Object.keys(breakpoints).includes(prop);
    }).map(function (label) {
      return above(label)(_templateObject, fn(props[label], props));
    });
  };
};